import type { FaireProductEntity } from "../../entity_types/product";

export const p_4635p5cfww: FaireProductEntity = {
  token: "p_4635p5cfww",
  type: "product",
  name: "Streetlevel",
  brandToken: "b_d3mdkn2j3h",
  brandName: "Verve Coffee Roasters",
  imageUrl:
    "https://cdn.faire.com/fastly/72289129d12deb0b9a5ebe09be599797ee51127801ad32347584c8803e34d0a2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/439ea18bab33c6a09521cf278324ed9c26e49a872dc3b24e51f36872b717e347.png",
    "https://cdn.faire.com/fastly/0e83fce5e6f0d3d77e0f84aad59ffae9a10a4dfc4bd0a66abe85a3599b30514f.png",
  ],
  priceDollars: 79,
  description:
    "Our flagship blend, Streetlevel, is built for balance and approachability and is delicious with any brew method, including espresso. Streetlevel's profile of Guatemalan, Colombian, and Honduran coffees anchors the blend and imparts a complex sweetness with honeyed citrus and red apple notes. This would be the first track if we made a greatest hits tape.",
  tags: [],
  msrpDollars: 158,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:08.633Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
